import { metricKeys } from '@pulse/metrics';
import { isNumber } from 'lodash';

/** metrics need to calculate sample secondary filter percentage */
export const metricsToCallSSFPct = [metricKeys.AverageRequestCount, metricKeys.AppUniqueDevices];

export const getSSFPctMetric = (metric) => `${metric}::ssfPct`;
export const getPctMetric = (metric) => `${metric}::pct`;

export function calcPercentage(total?: number, value?: number) {
  if (!isNumber(total) || !isNumber(value)) {
    return 'NA';
  }
  const pct = (value / total) * 100;
  return Number.isNaN(pct) || !Number.isFinite(pct) ? 'NA' : pct;
}
